import React, { FC } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Dashboard from '../pages/Dashboard'
import InvalidLinkPage from '../pages/InvalidLinkPage'
import NotAuthorized from '../pages/NotAuthorized'
import ResponsiveContextProvider from '../components/context/ResponsiveContextProvider'
import { Login } from '../pages/LoginCustom'

// Ory Elements
// optional fontawesome icons
import '@ory/elements/assets/fa-brands.min.css'
import '@ory/elements/assets/fa-solid.min.css'
import '@ory/elements/assets/fontawesome.min.css'

// optional fonts
import '@ory/elements/assets/inter-font.css'
import '@ory/elements/assets/jetbrains-mono-font.css'

// required styles for Ory Elements
import '@ory/elements/style.css'
import { CustomLanguageFormats, CustomTranslations, IntlProvider, locales, ThemeProvider } from '@ory/elements'
import { Registration } from '../pages/Registration'
import { Recovery } from '../pages/Recovery'
import { Verification } from '../pages/Verification'
import PrivateRoute from './PrivateRoute'
//import { CustomLanguageFormats } from '@ory/elements'

// adds custom translations labels to the default translations
//
// You can also contribute your custom translations to the Ory Elements project
// by submitting a pull request to the following repository:
// https://github.com/ory/elements
const customTranslations: CustomLanguageFormats = {
  en: {
    ...locales.en,
    'login.title': 'Login',
    'identities.messages.1070004': 'Email',
  },
  nl: {
    ...locales.nl,
    'login.title': 'Inloggen',
    'identities.messages.1070004': 'E-mail',
  },
  sr: {
    // merging English since no default Serbian translations are available
    ...locales.en,
    'login.title': 'Uloguj se',
    'identities.messages.1070004': 'E-mail',
  },
}

const AppRouter: FC = () => {
  return (
    <BrowserRouter>
      {/* We add the Ory themes here  */}
      {/* We add the Ory themes here */}
      <ThemeProvider themeOverrides={{}}>
        {/* We dont need to pass any custom translations */}
        {/* <IntlProvider> */}
        {/* We pass custom translations */}
        <IntlProvider<CustomTranslations> locale='sr' defaultLocale='sr' customTranslations={customTranslations}>
          <ResponsiveContextProvider>
            <Routes>
              <Route
                path='/'
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route path='/login' element={<Login />} />
              <Route path='/recovery' element={<Recovery />} />
              <Route path='/registration' element={<Registration />} />
              <Route path='/verification' element={<Verification />} />
              <Route path='/:nav' element={<Dashboard />} />
              <Route path='/InvalidLink' element={<InvalidLinkPage />} />
              <Route path='/not-authorized' element={<NotAuthorized />} />
            </Routes>
          </ResponsiveContextProvider>
        </IntlProvider>
      </ThemeProvider>
    </BrowserRouter>
  )
}

export default AppRouter
